/**
 * notify-downstream-message.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { validateAs, validateFor, validateTSEnum }
  from "../../validation/decorators";
import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

export enum NotificationLevel
{
  Info,
  Urgent,
  Error
}

export enum NotificationSource
{
  Admin,
  Server
}

@validateFor(MessageTag.DOWN_NOTIFY)
export class NotifyDownstreamMessage extends IncomingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.DOWN_NOTIFY;

  @validateAs("string")
  public message : string;

  @validateTSEnum(NotificationSource)
  public source : NotificationSource;

  @validateTSEnum(NotificationLevel)
  public level : NotificationLevel;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/notify-downstream-message.ts